// @flow

import _ from "lodash";
import * as React from "react";

import { Button, ButtonGroup } from "react-bootstrap";

import "./ConfidenceButtons.css";

type Props = {
  submit: (value: number) => void,
  selected: ?number
};

const ConfidenceButtons = (props: Props) => (
  <div className="ConfidenceButtons">
    <ButtonGroup>
      {_.range(21).map(n => {
        const percent = n * 5;
        return (
          <Button
            key={n}
            onClick={(e: Event) => {
              props.submit(percent);
              if (typeof e.target.blur === "function") {
                e.target.blur();
              }
            }}
            active={props.selected === percent}
            className="ConfidenceButtons-Button"
          >
            {percent}
          </Button>
        );
      })}
    </ButtonGroup>
  </div>
);

export default ConfidenceButtons;



// WEBPACK FOOTER //
// ./src/components/ConfidenceButtons/ConfidenceButtons.js